import { FamilyApplicationPaths } from './family_application_route_paths'
import { ProviderPaths } from '@/routing/provider_route_paths'
import { ReimbursementsPaths } from '@/routing/reimbursements_route_paths'
import { PaymentsAppealsPaths } from '@/routing/payments_appeals_route_paths.ts'

export const AppRoutePaths = {
  index: '/',
  auth: {
    login: '/login',
    login_test: '/login_test',
    twofa: '/twofa',
    forgot_password: {
      index: '/forgot_password',
      enter_email: '/forgot_password/enter_email',
      check_email: '/forgot_password/check_email',
    },
    reset_password: '/reset_password',
    register: '/sign_up',
    registration_invite: '/registration_invite',
    email_verification: '/email_verification',
    no_access: '/no_access',
  },
  sso_logout: {
    index: '/sso-logout',
  },
  maintenance: {
    index: '/maintenance',
  },
  messages: {
    index: '/messages',
  },
  documents: {
    index: '/documents',
  },
  renewal_bridge: {
    index: '/renewal_bridge',
  },
  privacy_statement: {
    index: '/privacy_statement',
  },
  home: {
    index: '/home',
  },
  dashboard: {
    index: '/dashboard',
  },
  marketplace: {
    index: '/marketplace',
    provider: {
      index: '/marketplace/provider/:providerId',
    },
    affiliation: {
      index: '/marketplace/affiliation/:affiliationId',
    },
    cart: {
      index: '/marketplace/cart',
    },
    details: {
      index: '/marketplace/:itemId/details',
    },
  },
  marketplace_preview: {
    index: '/marketplace-preview',
    details: '/marketplace-preview/:itemId/item-details',
    provider_details: '/marketplace-preview/:providerId/provider-details',
    affiliation_details:
      '/marketplace-preview/:affiliationId/affiliation-details',
  },
  marketplace_view: {
    index: '/marketplace-view',
    details: '/marketplace-view/:itemId/item-details',
    provider_details: '/marketplace-view/:providerId/provider-details',
    affiliation_details: '/marketplace-view/:affiliationId/affiliation-details',
  },
  termsAndConditions: {
    index: '/terms-and-conditions',
  },
  payments: {
    index: '/payments',
    details: {
      index: '/payments/:paymentId/details',
    },
  },
  bills: {
    details: {
      index: '/bills/:id/details',
    },
  },
  payments_appeals: PaymentsAppealsPaths,
  transactions: {
    index: '/transactions',
    details: {
      index: '/transactions/:transactionId/details',
    },
  },
  notifications: {
    index: '/notifications',
  },
  my_account: {
    index: '/my_account',
  },
  assessments: {
    index: '/assessments',
  },
  external: {
    classWallet: 'https://classwallet.com/',
  },
  external_lang_specific: {
    en: {
      handbook: 'https://help.acescholarships.org/hc/en-us',
      helpCenter: 'https://help.acescholarships.org/hc/en-us',
    },
    es: {
      handbook: 'https://help.acescholarships.org/hc/en-us',
      helpCenter: 'https://help.acescholarships.org/hc/es',
    },
  },
  program_application: {
    index: '/program_application',
    wizard: {
      index: '/program_application/wizard',
      location_declaration: {
        index: '/program_application/wizard/location_declaration',
      },
      basic_info: {
        index: '/program_application/wizard/basic_info',
      },
      poc_info: {
        index: '/program_application/wizard/poc_info',
      },
      business_info: {
        index: '/program_application/wizard/business_info',
      },
      service_info: {
        index: '/program_application/wizard/service_info',
      },
      consent_review: {
        index: '/program_application/wizard/consent_and_review',
      },
      overview: '/program_application/wizard/overview',
    },
  },
  appeals: {
    index: '/appeals',
    id: '/appeals/:appealId',
    new: '/appeals/new',
    expense: { index: 'appeals/expense' },
    ineligeble_appeal: {
      application: '/appeals/application_appeal/:flag_id',
      priority: '/appeals/priority_appeal/:student_id',
    },
    resolved: { index: '/appeals/resolved' },
  },
  family_application_renewal: {
    index: '/renewal_application',
  },
  family_application: FamilyApplicationPaths,
  providers: ProviderPaths,
  reimbursements: ReimbursementsPaths,
} as const

export const PROVIDER_APPLICATION_URLS = AppRoutePaths.program_application
export const FAMILY_APPLICATION_URLS = AppRoutePaths.family_application
export const PROVIDERS_URLS = AppRoutePaths.providers
export const REIMBURSEMENTS_URLS = AppRoutePaths.reimbursements
export const IDENTITY_VERIFICATION_ROUTES =
  AppRoutePaths.family_application.identity_verification

export const getAppealDetailsUrl = (id: number | string) => {
  return AppRoutePaths.appeals.id.replace(':appealId', id.toString())
}
